<header class="header flex items-center justify-center">
  <nav class="nav flex items-center">
    <a class="nav-link" (click)="handleNavigate()">
      <img
        class="logo"
        src="assets/images/core/tf2-logo.png"
        width="150"
        height="32"
      />
    </a>

    <a
      class="home button rounded-6 button--style-white-04"
      (click)="handleNavigate()"
    >
      <svg-icon
        class="flex items-center justify-center s-16"
        src="assets/icons/shared/home.svg"
      >
      </svg-icon>
    </a>
    <span class="divider vertical h-24"></span>
    <app-header-games class="start"></app-header-games>
    @if (sessionService.profile()) {
    <app-header-balance
      [balance]="sessionService.balance()"
      [isShowBonusBalance]="
        !!(affiliatesService.bonuses()?.cases ?? 0) ||
        !!affiliatesService.bonuses()?.balance
      "
      [balanceType]="sessionService.balanceType()"
      (balanceChange)="sessionService.changeBalanceType($event)"
      class="center"
    ></app-header-balance>

    <app-header-user
      class="right"
      [user]="sessionService.profile()!"
      (click)="handleOpenMyProfileModal()"
    ></app-header-user>
    } @else {
    <app-login-button class="right login-button"></app-login-button>
    }
    <!--  -->
    <button
      class="subnav-mobile button padding-x-6 h-32 rounded-6 button--style-dropdown"
      (click)="uiService.toggleMobileState('nav')"
      [class.active]="uiService.isShowNav()"
    >
      <svg-icon
        class="flex items-center justify-center s-16"
        src="assets/icons/core/menu.svg"
      ></svg-icon>
    </button>
    <button
      class="chat-mobile button padding-x-6 h-32 rounded-6 button--style-dropdown"
      (click)="uiService.toggleMobileState('chat')"
      [class.active]="uiService.isShowChat()"
    >
      <svg-icon
        class="flex items-center justify-center s-16"
        src="assets/icons/core/chat.svg"
      ></svg-icon>
    </button>
  </nav>
</header>
<app-header-navigation [class.nav--open]="uiService.isShowNav()" />
